import React from 'react';
import styles from './Loader.module.css';

interface LoaderProps {
  fullscreen?: boolean;
  tabFullscreen?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ fullscreen = false, tabFullscreen = false }) => {
  const containerClass = fullscreen 
    ? styles.fullscreen 
    : tabFullscreen 
    ? styles.tabFullscreen 
    : '';

  return (
    <div className={`${styles.loadingContainer} ${containerClass}`}>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#4A4A4A]"></div>
    </div>
  );
}; 